import { legacyToNewFlowMap } from '@/config';
import {
  AmlCheckResponse,
  AmlHistoryItem,
  InvestigationHistoryItem,
} from '@/api';
import {
  AmlCheckData,
  AmlCheckItemData,
  InvestigationHistoryItemData,
} from '../models';

import { mapInvestigationItem } from './investigationHistoryMappers';
import { mapAmlHistoryItem } from './amlHistoryMappers';

const amlCheck = (response: AmlCheckResponse): AmlCheckData => {
  const { data } = response;
  const itemData = data.data as AmlHistoryItem;

  const mappedItem: AmlCheckItemData = mapAmlHistoryItem(itemData);
  const mappedData: AmlCheckData = {
    result: data.result,
    balance: data.balance,
    amlFlow: legacyToNewFlowMap[data.amlFlow] || data.amlFlow,
    discount: data.discount,
    discountDueTime: data.discountDueTime,
    promoFlow: data.promoFlow,
    usePromoFlow: data.usePromoFlow,
    devModeUsed: !!data?.devModeUsed,
    items: [mappedItem],
  };

  return mappedData;
};

const amlInvestigation = (response: AmlCheckResponse) => {
  const { data } = response;
  const itemData = data.data as InvestigationHistoryItem;
  console.log('1 amlCheckMappers', itemData);
  const mappedItem: InvestigationHistoryItemData =
    mapInvestigationItem(itemData);

  console.log('2 amlCheckMappers', mappedItem);

  const mappedData: AmlCheckData = {
    result: data.result,
    balance: data.balance,
    amlFlow: legacyToNewFlowMap[data.amlFlow] || data.amlFlow,
    discount: data.discount,
    discountDueTime: data.discountDueTime,
    promoFlow: data.promoFlow,
    usePromoFlow: data.usePromoFlow,
    devModeUsed: !!data?.devModeUsed,
    items: [mappedItem],
  };

  return mappedData;
};

export { amlCheck, amlInvestigation };
